import { render, staticRenderFns } from "./DepartmentTree.vue?vue&type=template&id=142a4980&scoped=true"
import script from "./DepartmentTree.vue?vue&type=script&lang=js"
export * from "./DepartmentTree.vue?vue&type=script&lang=js"
import style0 from "./DepartmentTree.vue?vue&type=style&index=0&id=142a4980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142a4980",
  null
  
)

export default component.exports